import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../components/site';
import type { SolutionImplementationJourney, SolutionImplementationMilestone } from './types';

function ImplDecor() {
  return (
    <div className="hosp-impl__decor" aria-hidden>
      <span className="hosp-impl__decor-icon">🏨</span>
      <span className="hosp-impl__decor-icon">📱</span>
      <span className="hosp-impl__decor-icon">⚡</span>
      <span className="hosp-impl__decor-icon">☁</span>
      <span className="hosp-impl__decor-icon">📊</span>
    </div>
  );
}

function MilestoneItem({
  milestone,
  index,
}: {
  milestone: SolutionImplementationMilestone;
  index: number;
}) {
  return (
    <li
      className={`hosp-impl__milestone hosp-impl__milestone--${index + 1}`}
      style={{ '--milestone-i': index } as React.CSSProperties}
    >
      <div className="hosp-impl__node-wrap">
        <div className="hosp-impl__node">
          <span className="hosp-impl__node-emoji" aria-hidden>
            {milestone.emoji}
          </span>
        </div>
        <span className="hosp-impl__phase">{milestone.phase}</span>
      </div>
      <div className="hosp-impl__copy">
        <h3 className="hosp-impl__title">{milestone.title}</h3>
        <p className="hosp-impl__desc">{milestone.description}</p>
        <div className="hosp-impl__highlights-wrap">
          <ul className="hosp-impl__highlights">
            {milestone.highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </li>
  );
}

export const SolutionHospitalityImplementation: React.FC<{
  journey: SolutionImplementationJourney;
}> = ({ journey }) => (
  <SiteSection id="implementation" className="hosp-impl">
    <ImplDecor />
    <SiteSectionHeader
      eyebrow={journey.eyebrow}
      title={journey.title}
      subtitle={journey.subtitle}
      align="center"
    />

    <div className="hosp-impl__track" aria-label="Implementation journey">
      <ol className="hosp-impl__milestones">
        {journey.milestones.map((milestone, index) => (
          <MilestoneItem key={milestone.id} milestone={milestone} index={index} />
        ))}
      </ol>
    </div>
  </SiteSection>
);
